import { TOUR_ATTRIBUTE } from "./runtime/constants";
import { attrNameFor } from "./config/target-registry";
import type { TourAttrTargetKey } from "./config/target-registry";

export { default as TourProvider } from "./components/TourProvider";
export { default as TourLauncher } from "./components/TourLauncher";
export { default as useTour } from "./hooks/use-tour";
export type { TourAttrTargetKey } from "./config/target-registry";
export type { TourContextValue, TourDefinition } from "./types/tour.types";

export const tourAttr = (key: TourAttrTargetKey): Record<string, string> => ({
  [TOUR_ATTRIBUTE]: attrNameFor(key),
});

export const tourAttrIf = (
  condition: boolean,
  key: TourAttrTargetKey,
): Record<string, string> => (condition ? tourAttr(key) : {});
